
import { Base } from '../base-component';

import './form-item-dfc-personal.component.scss';

import * as $ from 'jquery';

export class FormItemDfcPersonal extends Base {

	applyForm: HTMLFormElement;
	applyFormSubmit: Element[];
	applyFormRadio: Element[];

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.applyForm = this.element.querySelector('form') as HTMLFormElement;
		this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.applyFormRadio = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));

	}

	bindEvents() {

		this.applyFormRadio.map((item) => item.addEventListener('click', (event) => {
			const evt: any = event.target;
			const identificationField: any = this.applyForm.querySelector('input[name=identification]');
			const identificationType: any = evt.value;

			if (identificationType === 'said') {

				identificationField.classList.remove('form__input--identification--passport');
				identificationField.classList.add('form__input--identification');
				identificationField.placeholder = 'Enter you South Africa ID number';
				identificationField.type = 'number';

			} else {

				identificationField.classList.remove('form__input--identification');
				identificationField.classList.add('form__input--identification--passport');
				identificationField.placeholder = 'Enter you Passport number';
				identificationField.type = 'text';

			}

		}));

		this.applyFormSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.applyForm.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.applyForm.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.formsService.detect(this.applyForm, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

	}

}



// WEBPACK FOOTER //
// ./components/form-item-dfc-personal/form-item-dfc-personal.component.ts